import * as React from 'react'
import EditableItemName from './editable_item_name'

type ItemNameProps = {
  isCopy: boolean
  onChange?: (value: string) => void
  name: string
}

export default function ItemName({ isCopy, onChange, name }: ItemNameProps) {
  if (isCopy) {
    return <EditableItemName value={name} onChange={onChange} />
  }
  return name
}
